import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import EditQuiz from "./EditQuizDetails";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../redux/slice";
import { deleteQuiz, getQuizzes, publishOrUnpublish } from "../redux/thunk";
import { getLaws } from "../../components/LawCollegeQuiz/redux/lawCollegeSlice";
import { convertTermsToHtml, formatText1 } from "../utils";

const QuizStatus = () => {
  const [searchTerm, setSearchTerm] = useState("");
  // const [quizzes, setQuizzes] = useState([]);
  const { quizzes, selectedQuiz, showPopup, option } = useSelector(
    (state) => state.quizManagement,
  );
  const userId = JSON.parse(localStorage.getItem("user"))?.id;

  const { categories } = useSelector((state) => state.lawCollegeQuiz);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getQuizzes());
    dispatch(getLaws());
    // axios.get("/admin/quizzes").then((res) => setQuizzes(res.data));
  }, [dispatch]);

  const fetchParticipants = async (id, option) => {
    console.log("data to set", id);
    dispatch(
      setState({
        key: "selectedQuiz",
        value: id,
      }),
    );
    dispatch(
      setState({
        key: "option",
        value: option,
      }),
    );
    dispatch(
      setState({
        key: "showPopup",
        value: true,
      }),
    );
  };

  const closePopup = () => {
    dispatch(
      setState({
        key: "selectedQuiz",
        value: null,
      }),
    );
    dispatch(
      setState({
        key: "option",
        value: "",
      }),
    );
    dispatch(
      setState({
        key: "showPopup",
        value: false,
      }),
    );
  };
  const handleDelete = async (id) => {
    try {
      // const body = { quiz_id: Number(id), updated_by: Number(userId) };
      const res = await dispatch(
        deleteQuiz({ quiz_id: Number(id), updated_by: Number(userId) }),
      );
      if (res) {
        console.log(res);
        alert("soft deleted the quiz");
        dispatch(getQuizzes());
      }
    } catch (er) {
      console.error(er);
    }
  };
  const handlePublish = async (data) => {
    const id = data.id;
    try {
      const res = await dispatch(publishOrUnpublish({ id: id }));
      console.log(res?.payload?.messge);

      // alert("res", res?.payload?.messge);
      await dispatch(getQuizzes());
    } catch (err) {
      console.error(err);
    }
  };

  function formatText(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }

  const filteredQuizzes = quizzes?.filter((q) => {
    if (!searchTerm) return true; // no filter

    const term = searchTerm.toLowerCase();

    return (
      String(
        q.quiz_type === 1
          ? "Live Quiz"
          : q.quiz_type === 2
            ? "Practice Quiz"
            : "-",
      )
        .toLowerCase()
        .includes(term) ||
      String(q.title).toLowerCase().includes(term) ||
      String(q.status).toLowerCase().includes(term) ||
      new Date(q.start_date)
        .toLocaleString("en-IN")
        .toLowerCase()
        .includes(term) ||
      String(q.id).toLowerCase().includes(term)
    );
  });

  return (
    <div>
      <p style={{ fontSize: "20px", textAlign: "center" }}>
        View / Update Quizz(s)
      </p>
      <div className="grid grid-cols-1 rounded-3 p-1 bg-white shadow gap-4 relative ">
        <div
          className="table-responsive p-2 rounded-3"
          style={{ height: "70vh" }}
        >
          <div
            style={{
              position: "sticky",
              top: 0,
              background: "white",
              zIndex: 10,
              padding: "8px",
              display: "flex",
              gap: "2%",
            }}
          >
            <p>
              <strong>Search</strong>
            </p>
            <input
              type="text"
              className="form-control"
              value={searchTerm}
              style={{ width: "25%", height: "5vh" }}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {filteredQuizzes?.length > 0 && (
              <p>
                <strong>Matched Records Count : </strong>
                {filteredQuizzes?.length}
              </p>
            )}
          </div>

          {filteredQuizzes?.length > 0 ? (
            <table
              className="table  table-striped table-bordered text-15"
              style={{ height: "10vh", overflow: "auto" }}
            >
              <tbody>
                <tr className="bg-gray-200 text-gray-700">
                  <th className="text-center">Sl No</th>
                  <th className="text-center">Quiz Type</th>
                  <th className="text-center">Title</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Quiz Date</th>
                  <th className="text-center">Actions</th>
                </tr>
                {/* {quizzes?.map((q, index) => ( */}
                {filteredQuizzes?.map((q, index) => (
                  <tr key={q.id} className="hover:bg-gray-100">
                    <td className="text-center">{index + 1} </td>

                    <td className="text-center">
                      {q.quiz_type === 1
                        ? "Live Quiz"
                        : q.quiz_type === 2
                          ? "Practice Quiz"
                          : "-"}
                    </td>
                    <td className="text-center">{q.title}</td>
                    <td className="text-center">
                      <span
                      // className={`badge ${
                      //   q.status === "completed"
                      //     ? "badge-success"
                      //     : q.status === "ongoing"
                      //     ? "badge-info"
                      //     : "badge-warning"
                      // }`}
                      >
                        {q.status || "-"}
                      </span>
                    </td>
                    <td className="text-center">
                      {" "}
                      {new Date(q.start_date).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </td>
                    <td className="text-center">
                      <img
                        width="24"
                        height="24"
                        src="https://img.icons8.com/material-rounded/24/visible.png"
                        alt="visible"
                        style={{ cursor: "pointer" }}
                        title="view quiz"
                        onClick={() => fetchParticipants(q, "view")}
                      />
                      {(() => {
                        const regDate = new Date(q.registration_start_date);
                        const strtDate = new Date(q.start_date);
                        const now = new Date();

                        const isSameDateTime =
                          q.quiz_type === 1
                            ? regDate.getTime() < now.getTime()
                            : strtDate.getTime() < now.getTime();

                        return !isSameDateTime && q.status !== "deleted" ? (
                          <>
                            <img
                              width="24"
                              height="24"
                              style={{ cursor: "pointer" }}
                              src="https://img.icons8.com/material-rounded/24/create-new.png"
                              alt="create-new"
                              title="edit quiz"
                              onClick={() => fetchParticipants(q, "edit")}
                            />
                            <img
                              width="24"
                              height="24"
                              style={{ cursor: "pointer" }}
                              title="delete quiz"
                              onClick={() => handleDelete(q.id)}
                              src="https://img.icons8.com/material-sharp/24/filled-trash.png"
                              alt="filled-trash"
                            />
                          </>
                        ) : null;
                      })()}
                      {(q.status === "active" || q.status === "inactive") && (
                        <button onClick={() => handlePublish(q)}>
                          {q.status === "active" ? "Unpublish" : "Publish"}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: "red", textAlign: "center" }}>
              No Matching records Found
            </p>
          )}
          {/* Custom Popup Modal */}
          {showPopup && selectedQuiz && (
            <div className="popup-overlay">
              <div className="popup-content">
                {/* <button onClick={closePopup}>&times;</button> */}
                <img
                  width="20"
                  height="20"
                  src="https://img.icons8.com/ios/50/delete-sign--v1.png"
                  alt="delete-sign--v1"
                  style={{ float: "right", cursor: "pointer" }}
                  onClick={closePopup}
                />
                {option === "view" ? (
                  <>
                    <h3
                      className="mb-10"
                      style={{ fontSize: "23px", textAlign: "center" }}
                    >
                      {selectedQuiz.quiz_type === 1
                        ? "Live Quiz"
                        : selectedQuiz.quiz_type === 2
                          ? "Practice Quiz"
                          : ""}
                    </h3>
                    {/* {https://web1024.docmaster.in:5007/${selectedQuiz.image_url}} */}
                    {selectedQuiz.quiz_type === 2 &&
                      selectedQuiz?.image_url && (
                        <div
                          className="text-xl text-30 mb-3 bg-white mx-auto"
                          style={{
                            borderRadius: "50%",
                            width: "100px",
                            height: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            overflow: "hidden", // to keep it circular
                          }}
                        >
                          {selectedQuiz.image_url ? (
                            <img
                              src={`https://web1024.docmaster.in:5007/${selectedQuiz.image_url}`}
                              alt="no img"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover", // cover ensures it fills the circle
                              }}
                            />
                          ) : (
                            "-"
                          )}
                        </div>
                      )}
                    <h3 className="mb-10" style={{ fontSize: "18px" }}>
                      <strong>Title : </strong> {selectedQuiz.title}
                    </h3>
                    {/* <h3 className="mb-10" style={{ fontSize: "18px" }}>
                      <strong>Description : </strong> {selectedQuiz.description}
                    </h3> */}

                    <table className="table">
                      <thead>
                        <tr>
                          <th>Total Questions</th>
                          <th>Duration (Per Question)</th>
                          <th>Registration Type</th>
                          <th>Registration Fee</th>
                          <th>Registration Start</th>
                          <th>Registration End</th>
                          <th>Quiz Start Date</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{selectedQuiz.total_questions}</td>
                          <td>{selectedQuiz.duration_per_question} sec</td>
                          <td>
                            {selectedQuiz.registration_type === "paid"
                              ? `₹${selectedQuiz.registration_fee}`
                              : "Free"}
                          </td>
                          <td>
                            {selectedQuiz.registration_type === "paid"
                              ? `₹${selectedQuiz.registration_fee}`
                              : "-"}
                          </td>
                          <td>
                            {selectedQuiz.quiz_type === 1
                              ? new Date(
                                  selectedQuiz.registration_start_date,
                                ).toLocaleString("en-IN")
                              : "-"}
                          </td>
                          <td>
                            {selectedQuiz.quiz_type === 1
                              ? new Date(
                                  selectedQuiz.registration_end_date,
                                ).toLocaleString("en-IN")
                              : "-"}
                          </td>
                          <td>
                            {new Date(selectedQuiz.start_date).toLocaleString(
                              "en-IN",
                            )}
                          </td>
                          <td>
                            <span
                              style={{
                                color: selectedQuiz?.status !== "" && "blue",
                              }}
                              // className={`badge ${
                              //   selectedQuiz.status === "qualified"
                              //     ? "badge-success"
                              //     : selectedQuiz.status === "disqualified"
                              //     ? "badge-danger"
                              //     : "badge-warning"
                              // }`}
                            >
                              {selectedQuiz.status || "-"}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <br />
                    <h4 className="mt-15">Scoring Details:</h4>
                    <ul style={{ marginLeft: "2%" }}>
                      <li>
                        Marks per Question: {selectedQuiz.marks_per_question}
                      </li>
                      <li>
                        Negative Marks (Wrong):{" "}
                        {selectedQuiz.negative_marks_wrong}
                      </li>
                      <li>
                        Negative Marks (Skipped):{" "}
                        {selectedQuiz.negative_marks_skipped}
                      </li>
                    </ul>

                    {/* {selectedQuiz.prizes && (
                      <>
                        <h4 className="mt-10">Prizes:</h4>
                        <ul style={{ marginLeft: "2%" }}>
                          {Object.entries(selectedQuiz.prizes).map(
                            ([rank, prize]) => (
                              <li key={rank}>
                                Rank {rank}: ₹{prize}
                              </li>
                            )
                          )}
                        </ul>
                      </>
                    )} */}

                    {selectedQuiz.prizes !== "" ? (
                      <>
                        <h5>Prize details</h5>
                        {selectedQuiz?.prizes &&
                          (typeof selectedQuiz.prizes === "object" ? (
                            <p style={{ color: "red" }}>Data format error</p>
                          ) : (
                            <div
                              style={{
                                marginTop: "10px",
                                lineHeight: "1.6",
                                marginBottom: "2%",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: formatText1(selectedQuiz.prizes),
                              }}
                            />
                          ))}
                      </>
                    ) : (
                      <></>
                    )}
                    {selectedQuiz.quizType === 1 &&
                      selectedQuiz.allotments?.length > 0 && (
                        <>
                          <h4 className="mt-10">Difficulty Allotment:</h4>
                          <ul style={{ marginLeft: "2%" }}>
                            {selectedQuiz.allotments.map((item, idx) => (
                              <li key={idx}>
                                {item.difficulty_level} – {item.percentage}%
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                    {selectedQuiz.allotments?.length > 0 &&
                      selectedQuiz?.quizType === 2 && (
                        <>
                          <h4 className="mt-10"> Law Selected:</h4>
                          {
                            categories.find(
                              (e) => e.id === selectedQuiz.allotments[0]?.law,
                            )?.name
                          }

                          {/* <ul style={{ marginLeft: "2%" }}>
                        {categories?.map((e) => (
                          <option key={e.id} value={e.id}>
                            {e.name}
                          </option>
                        ))}{" "}
                      </ul> */}
                        </>
                      )}

                    <h2 style={{ fontSize: "18px" }}>About Quiz</h2>
                    <p>{selectedQuiz.about_quiz}</p>
                    <h2 style={{ fontSize: "18px" }}>Terms & Conditions</h2>
                    <p>
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            selectedQuiz?.quiz_type === 1
                              ? convertTermsToHtml(selectedQuiz.quiz_terms)
                              : formatText(selectedQuiz?.quiz_terms),
                        }}
                      />
                    </p>
                  </>
                ) : (
                  <EditQuiz allotments={selectedQuiz.allotments} />
                )}
              </div>
            </div>
          )}

          {/* Simple CSS styles */}
          <style>{`
                .popup-overlay {
                  position: fixed;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  background-color: rgba(0,0,0,0.5);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  z-index: 1000;
                }
        
                .popup-content {
                  background: #fff;
                  padding: 20px;
                  border-radius: 8px;
                  width: 100%;
                  max-width: 1000px;
                  max-height: 90vh;
                  overflow-y: auto;
                  position: relative;
                }
        
                .close-btn {
                  position: absolute;
                  right: 12px;
                  top: 10px;
                  font-size: 24px;
                  background: none;
                  border: none;
                  cursor: pointer;
                }
        
                .close-btn:hover {
                  color: red;
                }
              `}</style>
        </div>
      </div>
    </div>
  );
};

export default QuizStatus;
